
import {DealerMgmtService} from "@/api/modules/dealerManagement/services/DealerMgmtService";

export class DealerManagement {

    constructor(auth) {


        if (auth == null) {
            throw new Error("[e298173] auth missing on DealerManagement");
        }

        this.auth = auth;
        this.service = new DealerMgmtService(this.auth);

    }

    createDealer(account, homeBranch, companyId){

        return new Promise((resolve, reject) => {

            if (account == null || account.length === 0){
                throw new Error("[e464831-ADM] account cannot be a null or empty string");
            }

            if (homeBranch == null || homeBranch.length === 0){
                throw new Error("[e576550-ADM] homeBranch cannot be a null or empty string");
            }

            if (companyId == null || companyId.length === 0){
                throw new Error("[e250877-ADM] companyId cannot be a null or empty string");
            }

            window.tracer.verbose(`[v697095] Create Dealer with account: ${account}, homeBranch ${homeBranch}, companyId ${companyId}`);

            this.service.createDealer(account, homeBranch, companyId).then(() => {
                window.tracer.debug(`[d847047-ADM] Dealer account \'${account}\' created`);
                resolve();
            }).catch(e => {

                window.tracer.error("[i522214-ADM] SERVER ERROR: Failed to create dealer account.");
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });

        });
    }

    updateDealer(account, homeBranch, companyId){

        return new Promise((resolve, reject) => {

            if (account == null){
                throw new Error("[e712067-ADM] account cannot be a null object");
            }

            if (homeBranch == null){
                throw new Error("[e554854-ADM] homeBranch cannot be a null object");
            }

            if (companyId == null){
                throw new Error("[e495059-ADM] companyId cannot be a null object");
            }


            this.service.updateDealer(account, homeBranch, companyId).then(() => {
                window.tracer.info("[i487158] Dealer account updated");
                resolve();
            }).catch(e => {

                window.tracer.info("[i963682] Failed to update dealer account.");
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });

        });
    }

    existAccount(account) {

        return new Promise((resolve, reject) => {

            if (account == null || account.length === 0){
                window.tracer.warn("[w118518] Empty string or null as account number. Check caller. It is not allowed. Next statement will raise an error");
                throw new Error("[e130399] An empty string or null (undefined) as account number is not allowed");
            }

            this.service.existsDealerAccount(account).then((exists) => {

                resolve(exists);

            }).catch(e => {

                window.tracer.error(`[e627639] Server Error when checking if dealer account \'${account}\' exists`);
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });

        });
    }


}